import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import api from 'helpers/api'
import ResponseMessage from 'components/common/ResponseMessage/ResponseMessage'
import PhoneNumber from 'components/RCPro/components/form/PhoneNumber/PhoneNumber'
import Email from 'components/RCPro/components/form/Email/Email'
import Link from 'components/common/Link/Link'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import style from './Contacts.module.scss'

const RCProContacts = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const [ errorMessage, setErrorMessage ] = useState(false)
  const { contacts, activity: { domains } } = state.texts

  // Initialize form
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    control
  } = useForm({
    ...formParams,
    values: {
      email: state.email || '',
      phone: state.phone?.number || ''
    },
  })

  const onSubmit = handleSubmit(async data => {
    setErrorMessage(false)
    try{
      const {
        contractType,
        priceType,
        rateType,
        firstname,
        lastname,
        organizationName,
        companyImmatriculation,
        headquarterAddress,
        headquarterCity,
        domain,
        activity,
        turnover
      } = state

      const { sector, codeProduct } = domains.find( option => option.sector === domain )
      const { email, phone: { number } } = data

      const resPrice = await api.get({
        url: `/rater/${codeProduct}/${turnover}/${activity}`,
        headers: {
          Authorization: `Bearer ${state.token}`
        }
      })

      if (resPrice.total_ttc){
        const price = (Number(resPrice.total_ttc) / 12).toFixed(2)
        const res = await api.post({
          url: '/adhesions/client',
          data: {
            contractType,
            priceType,
            rateType,
            firstname,
            lastname,
            organizationName,
            companyImmatriculation,
            headquarterAddress,
            headquarterCity,
            sector,
            codeProduct,
            activity,
            turnover,
            price,
            email,
            phone: number,
            areTermsAccepted: true,
            paymentPlan: 'year',
            birthdate: '01/01/2000',
            transactionHorodate: new Date().toISOString()
          },
          headers: {
            Authorization: `Bearer ${state.token}`
          },
        })
  
        if (res?.response) {
          nextPage({ pathname, state, navigate, data: {
            ...data,
            price,
            adhesionId: res.response.id
          } })
          nextPageTransition()
        } else {
          setErrorMessage(true)
        }
      } else {
        setErrorMessage(true)
      }
    } catch (error) {
      setErrorMessage(true)
    }
  })

  return (
    <>
      <h1>{contacts.title} 💌</h1>

      <form onSubmit={onSubmit}>
        {errorMessage &&
          <ResponseMessage
            className={style.error}
            label={t('common:form.genericError')}
          />
        }

        <Email
          register={register}
          error={errors.email}
        />

        <PhoneNumber
          control={control}
          error={errors.phone}
          value={state?.phone?.number || ''}
        />

        <p className={style.legalterms}>
          {contacts.legalterms}
          &nbsp;
          <Link
            target={'_blank'}
            label={contacts.link}
            to={'https://www.get-owen.com/fr/politique-de-confidentialite'}
          />
        </p>

        <Button
          label={<>{contacts.button} <Arrow /></>}
          onClick={handleSubmit}
          className={style.button}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProContacts